
// theme/scripts/components/button.js

import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import SelectComponent from '../common/select';
import { CustomizeContext } from '../contexts/customize';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_button_option'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmButton = () => {
  const [list, setList] = useState([]);
  const [error, setError] = useState(null);
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  useEffect(() => {
    let mounted = true;
    const getList = async () => {
      try {
        const response = await client.get('?product_id=' + productId);
        if (!mounted) return;

        const buttonList = response.data.result || [];
        setList(response.data.result);

        const reorderRaw = sessionStorage.getItem('reorder_properties');
        if (!reorderRaw) return;

        const reorderData = JSON.parse(reorderRaw);
        const reorderLabel = reorderData._Button;
        
        const matched = buttonList.find((item) => item.label === reorderLabel);
        if (!matched) {
          setError(`Saved value: Button "${reorderLabel}" does not exist in this fabric. Please select again.`);
          return;
        }

        if (matched) {
          setCustomizes((prev) => ({
            ...prev,
            button: {
              id: matched.id,
              label: matched.label,
              value: matched.value,
              img: matched.image_url
            }
          }));
        }
      } catch (err) {
        setError('❌ APIエラーによりボタン情報を取得できませんでした。');
      }
    };
    getList();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
      const reorderRaw = sessionStorage.getItem('reorder_properties');
      if (!reorderRaw) return;
  
      const el = document.getElementById('mtm-button');
      if (el) {
        el.classList.add('active');
        el.nextElementSibling?.classList.add('active');
      }
    }, [list]);

  if (!list || list.length === 0) return null;

  return (
    <div className="mtm-item__wrapper" id="mtm-button">
      <h3 className="mtm-item__title">BUTTON</h3>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className="mtm-item__selects row row-cols-2 row-cols-md-5">
        {list.map((item, ind) => (
          <SelectComponent
            item={item}
            ind={ind}
            name="button"
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MtmButton;
